import { render, staticRenderFns } from "./MethodPreview.vue?vue&type=template&id=474a4848&"
import script from "./MethodPreview.vue?vue&type=script&lang=js&"
export * from "./MethodPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports